import { render, staticRenderFns } from "./checkContract.vue?vue&type=template&id=71a488bf&scoped=true"
import script from "./checkContract.vue?vue&type=script&lang=js"
export * from "./checkContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a488bf",
  null
  
)

export default component.exports